import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsMobile, useT } from '@repo/common';
import HeaderText from '../../Common/HeaderText';

const DeleteAccount = ({ onDeleteOpen, children }) => {
  const t = useT();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleDelete = () => {
    onDeleteOpen(true);
    navigate('/mypage/delete-account');
  };

  return (
    <div className='flex flex-col max-w-[568px] w-full items-start tabletH:pb-[60px]'>
      <HeaderText label={t('Account', '계정')} />

      <div className='flex flex-col gap-6 w-full'>
      {children}

      {isMobile ? (
        <div className='flex flex-col w-full'>
          <div className='flex items-center justify-between w-full h-6'>
            <div className='typo-b14Strong text-text-primary'>
              {t('Delete account', '계정 삭제')}
            </div>
            <button
              className='shrink-0 px-1.5 typo-b12Strong text-text-primary underline'
              onClick={handleDelete}
            >
              {t('Delete', '삭제')}
            </button>
          </div>
          <div className='typo-b12 text-text-placeholder'>
            {t(
              'Your profile and activity will be permanently removed.',
              '프로필과 활동 내역이 영구적으로 삭제됩니다.',
            )}
          </div>
        </div>
      ) : (
        <div className='flex justify-between w-full'>
          <div className='flex pr-2 flex-col items-start gap-0.5 w-full'>
            <div className='typo-b14Strong text-text-primary'>
              {t('Delete account', '계정 삭제')}
            </div>
            <div className='typo-b12 text-text-placeholder'>
              {t(
              'Your profile and activity will be permanently removed.',
              '프로필과 활동 내역이 영구적으로 삭제됩니다.',
            )}
            </div>
          </div>
          <button
            className='typo-b14 text-text-primary underline'
            onClick={handleDelete}
          >
            {t('Delete', '삭제')}
          </button>
        </div>
      )}
      </div>
    </div>
  );
};

export default DeleteAccount;
